var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"user-overlay"},[_c('transition',[_vm._t("default")],2)],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }